import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import {useLanguage} from "../../hooks/useLanguage";

export const ProgressIndicator = (props) => {

  const { selectedLanguage } = useLanguage();

  const LTR = selectedLanguage === 'ar' || selectedLanguage === 'ur' || selectedLanguage === 'fa';

  return (
    <React.Fragment>
      <div
        className={`indicator-container ${
          props.value === 0 ? 'inactive' : props.value === 100 ? 'inactive' : 'active'
        }`}
      >
        <Box mx={4} mb={2}>
          <Typography variant={'subtitle1'} align={'center'}>
            <span
              className={`progress-indicator-number-icon ${
                props.value === 0 ? 'inactive' : props.value === 100 ? 'inactive' : 'active'
              }`}
            >
              {props.number}
            </span>{' '}
            {props.label}
          </Typography>
        </Box>
        <LinearProgress style={{ rotate: LTR ? "180deg" : null}} value={props.value} variant={'buffer'} valueBuffer={100} />
      </div>
    </React.Fragment>
  );
};

export default ProgressIndicator;
